module.exports = __webpack_public_path__ + "static/media/codinglogo.2f2547cc.svg";